import React from 'react';
import { motion } from 'framer-motion';
import curvedlines from '../../Assets/Home/curvedlines.svg';

const CoreValues = () => {
  const items = [
    {
      title: 'Excellence',
      description: 'We strive for excellence in everything we do, delivering high-quality solutions that exceed expectations.',
    },
    {
      title: 'Integrity',
      description: 'Integrity is at the heart of our ethical standards, building trust with client and stakeholders.',
    },
    {
      title: 'Innovation',
      description: 'We foster a culture of innovation, continuously seeking new ideas and approaches to drive progress.',
    },
    {
      title: 'Client-Centric',
      description: "We are dedicated to understanding and meeting our client's needs by prioritizing client satisfaction.",
    },
  ];

  // Animation variants
  const circleVariant = {
    hidden: { opacity: 0, scale: 0.5, x: -100 },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      x: 0,
      transition: {
        delay: i * 0.4,
        type: 'spring',
        stiffness: 100,
      },
    }),
  };

  const descriptionVariant = {
    hidden: { opacity: 0, x: 100 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.8 + i * 0.4,
        type: 'spring',
        stiffness: 50,
      },
    }),
  };

  return (
    // <div className="relative core-value px-4 md:px-8 max-lg:hidden"></div>
    //   <div className="flex flex-col items-center gap-6 md:gap-8 py-8">
    //     <p className="text-stone-800 text-xl md:text-2xl font-bold core-value">
    //       Core <span className="purple">Values</span>
    //     </p>
    //     <p className="text-center text-lg md:text-2xl xl:text-4xl font-semibold darkblue max-w-4xl">
    //       Trust is a vitally important <span className="purple">value that every</span> organization should have
    //     </p>
    //   </div>

    //   <div className="relative w-full  ">
    //     <img
    //       src={curvedlines}
    //       alt="Curved Lines"
    //       className="max-lg:hidden md:block absolute z-0 md:w-[60%] md:left-[10%] top-[10%]"
    //     />

       
    //     <div className="relative z-10 flex flex-col gap-10 md:gap-14">
        
    //       <div className="flex flex-col max-md:ml-0 ml-[20px]  md:flex-row items-center justify-center md:justify-around gap-8 md:gap-12">
    //         {items.slice(0, 2).map((item, index) => (
    //           <motion.div
    //             key={index}
    //             initial="hidden"
    //             animate="visible"
    //             custom={index}
    //             variants={circleVariant}
    //             className="flex flex-col items-center md:flex-row md:w-[45%] gap-4"
    //           >
    //             <motion.div
    //               initial="hidden"
    //               animate="visible"
    //               custom={index}
    //               variants={circleVariant}
    //               className="flex items-center justify-center text-sm md:text-md font-semibold text-white rounded-full w-24 h-16 md:w-24 md:h-24 bg-[#8364C3] shadow-md"
    //             >
    //               <p className="text-center ">{item.title}</p>
    //             </motion.div>
    //             <motion.p
    //               initial="hidden"
    //               animate="visible"
    //               custom={index}
    //               variants={descriptionVariant}
    //               className="text-sm md:text-lg text-center md:text-left max-w-xs md:max-w-md"
    //             >
    //               {item.description}
    //             </motion.p>
    //           </motion.div>
    //         ))}
    //       </div>

    //       <div className="flex flex-col max-md:ml-0 [1500px]:ml-[650px] ml-[400px] md:flex-row items-center justify-center md:justify-around gap-8 md:gap-12">
    //         {items.slice(2, 4).map((item, index) => (
    //           <motion.div
    //             key={index}
    //             initial="hidden"
    //             animate="visible"
    //             custom={index + 2}
    //             variants={circleVariant}
    //             className="flex flex-col items-center md:flex-row md:w-[45%] gap-4"
    //           >
    //             <motion.div
    //               initial="hidden"
    //               animate="visible"
    //               custom={index + 2}
    //               variants={circleVariant}
    //               className="flex items-center justify-center text-sm md:text-md font-semibold text-white rounded-full w-24 h-16 md:w-24 md:h-24  bg-[#8364C3] shadow-md"
    //             >
    //               <p className={`text-center px-8 `}>
    //                 {item.title}
    //               </p>
    //             </motion.div>
    //             <motion.p
    //               initial="hidden"
    //               animate="visible"
    //               custom={index + 2}
    //               variants={descriptionVariant}
    //               className="text-sm md:text-lg text-center md:text-left max-w-xs md:max-w-md"
    //             >
    //               {item.description}
    //             </motion.p>
    //           </motion.div>
    //         ))}
    //       </div>
    //     </div>
    //   </div>
    // </div>
  <></>

  );
};

export default CoreValues;
